import * as React from 'react';
import styleImg from './Tour.less';

interface TourProps extends React.ClassAttributes<any> { }

interface TourState {
    idx: number;
}

export class Tour extends React.Component<TourProps, TourState> {

    constructor(props: any) {
        super(props);
        this.state = {
            idx: 0
        };
        this.slideImg = this.slideImg.bind(this);

        this.imgs.push(require('../../img/tour/Tour1.png'));
        this.imgs.push(require('../../img/tour/Tour2.png'));
        this.imgs.push(require('../../img/tour/Tour3.png'));
        this.imgs.push(require('../../img/tour/Tour4.png'));
        this.imgs.push(require('../../img/tour/Tour5.png'));
        this.imgs.push(require('../../img/tour/Tour6.png'));
        this.imgs.push(require('../../img/tour/Tour7.png'));
    }

    private imgs: Array<any> = [];

    render(): JSX.Element {
        const winWidth = window.innerWidth;
        const imgWidthOrig = 1122;
        const imgHeightOrig = 841;// 793
        const margin = 120;
        const imgWidth = Math.min(imgWidthOrig, winWidth - margin - 100);
        const imgHeight = imgWidth / imgWidthOrig * imgHeightOrig;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', width: imgWidth + margin }}>
                <div style={{ display: 'flex', flexDirection: 'row', overflow: 'hidden' }}>
                    <div style={{ height: imgHeight }} className={styleImg.btn} onClick={() => this.slideImg(false)}>{'◁'}</div>
                    <div style={{ width: imgWidth, height: imgHeight, position: 'relative' }}>
                        {this.imgs.map((img: any, idx: number) =>
                            <img
                                key={`img-${idx}`}
                                style={{
                                    opacity: idx === this.state.idx ? 1 : 0,
                                    width: imgWidth
                                }}
                                className={styleImg.intro}
                                src={img}
                            />
                        )}
                    </div>
                    <div className={styleImg.btn} onClick={() => this.slideImg()}>{'▷'}</div>
                </div>
                <div className={styleImg.counter}>{`${(this.state.idx + 1)} / ${this.imgs.length}`}</div>
            </div>
        );
    }

    slideImg(forward = true): void {
        let { idx } = this.state;
        if (forward && idx < this.imgs.length - 1) {
            idx++;
        } else if (!forward && idx > 0) {
            idx--;
        }
        if (idx !== this.state.idx) {
            this.setState({ idx });
        }
    }

    // renderIndex(imgs: Array<any>) {
    //     return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '130px' }}>
    //         <div style={{ height: '57px', width: '100%', backgroundColor: '#c7d5ef' }}>&nbsp;</div>
    //         {
    //             imgs.map((img: any, idx: number) => {
    //                 const bgStyle = idx === this.state.idx ? { backgroundColor: '#c7d5ef' } : { backgroundColor: '#F0F0F0' };
    //                 return <div
    //                     onClick={() => this.setState({ idx })}                        >
    //                     <img src={img} style={{ width: '120px', ...bgStyle, padding: '5px', margin: '5px', borderRadius: '20px' }} />
    //                 </div>;
    //             })
    //         }
    //     </div>;
    // }
}
